<template>
  <div :class="className" :style="{ height: height, width: width, zoom: barzoom }" />
</template>

<script>
import * as echarts from 'echarts';
import {iswindows} from '@/utils/utils'
require('echarts/theme/macarons'); // echarts theme
const animationDuration = 2000;

export default {
  computed: {
    barzoom() {
      let zoom = window.devicePixelRatio;
      // return iswindows()?zoom:1
      return 1;
    },
  },
  watch: {
    series: {
      deep: true,
      // immediate: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "500px",
    },
    xdata: {
      //x轴得坐标
      type: Array,
      default: () => [],
    },
    series: {
      //每个坐标轴的值
      type: Array,
      default: () => [],
    },
    rotate: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    barcolor:{
      type:String,
      default:'#63C4C7'
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = this._.debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      let that = this;
      this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(
        {
          tooltip: {
           
            trigger: "axis",
             backgroundColor: '#fff', //提示框浮层的背景颜色。
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              if (that.type == "illness") {
                return params[0].data.value + "次";
              } else if (that.type == "spend") {
                return "平均" + params[0].data.value + "元";
              } else if (that.type == "age") {
                return params[0].data.datas[0] + "人," + "￥" + params[0].data.datas[1];
              } else if (that.type == "hospital") {
                return params[0].data.value + "次";
              }
            },
          },
          grid: {
            top: 10,
            // left: "-50%",
            left:120,
            // right: "2%",
            bottom: "30px",
            // containLabel: false,
          },
          color: [this.barcolor],
          xAxis: [
            {
              type: "value",
              minInterval: 1,
              axisTick: {
                show: false,
              },
              axisLine: {
               show: false, //隐藏y轴
              lineStyle: {
                color: '#999999',
              },
            },
              axisLabel: {
                formatter: this.unit + "{value}",
              },
              splitArea : {show : false}//去除网格区域
            },
          ],
          yAxis: [
            {
              type: "category",
              data: this.xdata,
              axisTick: {
                // alignWithLabel: true,
                show: false,
              },
              axisLine: {
               show: false, //隐藏y轴
              lineStyle: {
                color: '#999999',
              },
            },
              axisLabel: {
                interval: 0,
                fontSize: 12,
                width:110,
                 overflow: "breakAll",
              },
              splitArea : {show : false}//去除网格区域
            },
          ],
          series: this.series,
        },
        true
      );
    },
  },
};
</script>
